import { isFullCommitSha } from "@cmmd-forge/shared/buildCommit";

/**
 * Same document the app boots from; fetched with `cache: "no-store"` so the
 * answer is always the currently deployed server, never a cached copy.
 */
export const STALE_BUILD_DESCRIPTOR_PATH = "/.well-known/forge/environment";

/**
 * The server's build identity from a descriptor payload, or undefined when the
 * payload does not carry one. Tolerant of arbitrary shapes: on desktop and in
 * dev this endpoint can be proxied into HTML or an error body, and a watchdog
 * that throws on that would turn a health check into a crash loop.
 */
export function readServerBuildCommit(payload: unknown): string | undefined {
  if (typeof payload !== "object" || payload === null) return undefined;
  const candidate = (payload as { readonly buildCommit?: unknown }).buildCommit;
  return typeof candidate === "string" ? candidate : undefined;
}

/**
 * A reload prompt is only honest when both sides positively identify a build
 * and they disagree. An absent or placeholder commit on either side means
 * "unknown", and unknown must never produce a prompt: desktop and dev builds
 * carry no commit, and prompting there would nag users whose bundle cannot be
 * stale (it is served by the same process that answers the descriptor).
 */
export function shouldPromptStaleBuildReload(input: {
  readonly clientCommit: string | undefined;
  readonly serverCommit: string | undefined;
}): boolean {
  if (!isFullCommitSha(input.clientCommit) || !isFullCommitSha(input.serverCommit)) {
    return false;
  }
  return input.clientCommit?.toLowerCase() !== input.serverCommit?.toLowerCase();
}
